import styled from '@emotion/styled'

import type { FC } from 'react'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import IconWrapper from '@segment/matcha/components/IconWrapper'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import data from './data'

const copy = {
  heading: `AI that’s trusted by data scientists and instantly actionable for marketers`,
}

const Overview: FC = () => (
  <StyledSectionBase variant="centered">
    <Section.Copy>
      <StyledCopy centered={true}>
        <CopyText.Heading tag="h2" variant="h2">
          {copy.heading}
        </CopyText.Heading>
      </StyledCopy>
    </Section.Copy>
    <Section.Contents>
      <ColumnTrack columns={1} overrides={{ md: 3 }}>
        {data.items.map(({ icon: Icon, headline, description }) => (
          <FeatureBoxBase key={headline} headerPosition="top" alignment="left">
            <FeatureBox.Header>
              <IconWrapper variant="circle" elevation={1}>
                <Icon />
              </IconWrapper>
            </FeatureBox.Header>
            <FeatureBox.Body>
              <FeatureBox.Title>{headline}</FeatureBox.Title>
              <FeatureBox.Text>{description}</FeatureBox.Text>
            </FeatureBox.Body>
          </FeatureBoxBase>
        ))}
      </ColumnTrack>
    </Section.Contents>
  </StyledSectionBase>
)

const StyledCopy = styled(CopyTextBase)`
  max-width: 690px;
`

const StyledSectionBase = styled(SectionBase)`
  max-width: 1260px;
`

export default Overview
